const translations = {
    en: {
        news: {
            header: "LATEST NEWS",
            title: "Check out the news in real time",
            text: "Stay up to date even at the hotel: don't miss the latest and most reliable news from the major newspapers",
            no_news: "There are no news."
        }
    },
    de: {
        news: {
            header: "NEUESTE NACHRICHTEN",
            title: "Schauen Sie sich die Nachrichten in Echtzeit an",
            text: "Bleiben Sie auch im Hotel auf dem Laufenden: Verpassen Sie nicht die neuesten und zuverlässigsten Nachrichten aus den großen Zeitungen",
            no_news: "Es gibt keine Neuigkeiten."
        }
    },
    es: {
        news: {
            header: "ULTIMAS NOTICIAS",
            title: "Echa un vistazo a las noticias en tiempo real.",
            text: "Manténgase actualizado incluso en el hotel: no se pierda las noticias más recientes y confiables de los principales periódicos.",
            no_news: "No hay noticias."
        }
    },
    fr: {
        news: {
            header: "DERNIÈRES NOUVELLES",
            title: "Consultez les nouvelles en temps réel",
            text: "Restez à jour même à l'hôtel: ne manquez pas les dernières nouvelles les plus fiables des principaux journaux",
            no_news: "Il n'y a pas de nouvelles."
        }
    },
    it: {
        news: {
            header: "ULTIME NOTIZIE",
            title: "Scopri le news in tempo reale",
            text: "Rimani sempre aggiornato anche in hotel: non perdere le notizie più recenti e affidabili delle testate principali",
            no_news: "Non ci sono notizie."
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/news/News.js